module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright-f"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('em', [_vm._v("Millstone of Doubt")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2022 by Erica Vetsch")])]), _c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Published by Kregel Publications, a division of Kregel Inc., 2450 Oak Industrial Dr. NE, Grand Rapids, MI 49505. ")]), _c('a', {
    attrs: {
      "href": "http://www.kregel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kregel.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—for example, electronic, mechanical, photocopy, recording, or otherwise—without the publisher’s prior written permission or by license agreement. The only exception is brief quotations in printed reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Published in association with the Books & Such Literary Management, 52 Mission Circle, Suite 122, PMB 170, Santa Rosa, CA 95409-5370, "), _c('a', {
    attrs: {
      "href": "http://www.booksandsuch.com",
      "target": "_blank"
    }
  }, [_vm._v("www.booksandsuch.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("The persons and events portrayed in this work are the creations of the author, and any resemblance to persons living or dead is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Names: Vetsch, Erica, author.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Title: Millstone of doubt / Erica Vetsch.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Description: Grand Rapids, MI : Kregel Publications, [2022] | Series: Thorndike & Swann regency mysteries")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Identifiers: LCCN 2022017622 (print) | LCCN 2022017623 (ebook) | ISBN 9780825447143 (paperback) | ISBN 9780825469145 (kindle edition) | ISBN 9780825477614 (epub)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Subjects: LCGFT: Mystery fiction. | Novels.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Classification: LCC PS3622.E886 M55 2022 (print) | LCC PS3622.E886 (ebook) | DDC 813/.6--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022017622",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022017622")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022017623",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022017623")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN 978-0-8254-4714-3, print")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978-0-8254-7761-4, epub")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978-0-8254-6914-5, Kindle")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-c1"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-c"
  }, [_vm._v("22 23 24 25 26 27 28 29 30 31 / 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-651aac1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Copyright.vue
// module id = 69
// module chunks = 0